export enum TextAlign {
  Left = 'Left',
  Center = 'Center',
  Right = 'Right',
}

const TextAlignMap: { [key in TextAlign]: TextAlign } = {
  [TextAlign.Left]: TextAlign.Left,
  [TextAlign.Center]: TextAlign.Center,
  [TextAlign.Right]: TextAlign.Right,
} as const;

const TextAlignList = Object.values(TextAlignMap);

export namespace TextAlign {
  export function values(): Readonly<TextAlign[]> {
    return TextAlignList;
  }

  export function load(value: string): TextAlign {
    return isTextAlign(value) ? value : TextAlign.Center;
  }

  export function dump(textAlign: TextAlign): string {
    return textAlign;
  }
}

function isTextAlign(value: string): value is TextAlign {
  return TextAlignList.some((align) => value === align);
}
